/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShipmentDraftsSummary
 */
export interface ShipmentDraftsSummary {
    /**
     * 
     * @type {number}
     * @memberof ShipmentDraftsSummary
     */
    count: number;
}

/**
 * Check if a given object implements the ShipmentDraftsSummary interface.
 */
export function instanceOfShipmentDraftsSummary(value: object): value is ShipmentDraftsSummary {
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function ShipmentDraftsSummaryFromJSON(json: any): ShipmentDraftsSummary {
    return ShipmentDraftsSummaryFromJSONTyped(json, false);
}

export function ShipmentDraftsSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipmentDraftsSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
    };
}

  export function ShipmentDraftsSummaryToJSON(json: any): ShipmentDraftsSummary {
      return ShipmentDraftsSummaryToJSONTyped(json, false);
  }

  export function ShipmentDraftsSummaryToJSONTyped(value?: ShipmentDraftsSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
    };
}

